import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-containerrr">
      <div class="three-body">
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
      </div>
    </div>
  );
};

export default Loader;
